import { getInitials } from '@/utils/userNames'
import { GetUserType } from '@orbit/api-types'
import React from 'react'
import { MemberAvatar } from './MembersSection/MembersSection.styles'

interface Props {
	/**
	 * Structurally typed to the three fields actually rendered, so callers that
	 * only carry avatar essentials (e.g. public-overview travelers) can reuse
	 * the same avatar as the member Balances rows.
	 */
	member: Pick<GetUserType, 'firstName' | 'lastName' | 'profilePicture'> | undefined
	size?: 'sm' | 'md'
}

export const Avatar: React.FC<Props> = ({ member, size = 'md' }) => (
	<MemberAvatar $size={size}>
		{member?.profilePicture ? (
			<img src={member.profilePicture} alt={getInitials(member)} />
		) : (
			getInitials(member)
		)}
	</MemberAvatar>
)
